import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Card, Image, Space, Typography, message, Spin } from "antd";
import { useState } from "react";
import { useBGRemove } from "../../_actions/bot";
import { useUploadFile } from "../../_actions/files";
import GeneralUploader from "../pdfEditor/Uploader";

const { Title, Text } = Typography;

export default function BGRemover() {
    const [resultUrl, setResultUrl] = useState(null);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showUploader, setShowUploader] = useState(true);

    const mutationBGRemove = useBGRemove((res) => {
        const file = res?.data?.file;

        if (file) {
            setResultUrl(`https://api.qureal.com/assets/${file.id}`);
            // message.success("Background removed successfully!");
        } else {
            message.error("Background removal failed.");
        }

        setLoading(false);
    });

    const { mutate: uploadFile } = useUploadFile((res) => {
        if (!res) {
            message.error("Failed to upload image.");
            setShowUploader(true);
            return;
        }

        setUploadedFile(res);
        setLoading(true);
        setShowUploader(false);
        mutationBGRemove.mutate({ filename: res.filename_disk });
    });

    const handleUploadChange = (info) => {
        const file = info?.file?.originFileObj || info?.file || info;
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        uploadFile(formData);
    };

    const handleDownload = () => {
        if (!resultUrl) return;

        const link = document.createElement("a");
        link.href = resultUrl;
        link.download = `${
            uploadedFile?.filename_download || "image"
        }_bg_removed.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleChangeImage = () => {
        setResultUrl(null);
        setUploadedFile(null);
        setShowUploader(true);
    };

    return (
        <div style={{ maxWidth: 800, margin: "0 auto" }}>
            <Space
                direction="vertical"
                size={40}
                style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    width: "100%",
                }}
            >
                <div>
                    <Title level={1}>AI Background Remover</Title>
                    <Text>
                        Remove the background from your images in one click
                    </Text>
                </div>

                {showUploader && (
                    <GeneralUploader
                        accept="image/*"
                        multiple={false}
                        showUploadList={false}
                        beforeUpload={() => false}
                        onChangeInfo={handleUploadChange}
                    />
                )}

                {loading && (
                    <div style={{ marginTop: 24 }}>
                        <Spin tip="Processing image..." size="large" />
                    </div>
                )}

                {resultUrl && !loading && (
                    <Card style={{ marginTop: 24 }}>
                        <Title level={4}>Processed Image</Title>
                        <Image
                            src={resultUrl}
                            alt="Processed"
                            preview={false}
                            style={{ maxHeight: 400 }}
                        />

                        <Space
                            style={{ marginTop: 14, width: "100%" }}
                            direction="vertical"
                        >
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownload}
                            >
                                Download
                            </Button>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={handleChangeImage}
                            >
                                Change Image
                            </Button>
                        </Space>
                    </Card>
                )}
            </Space>
        </div>
    );
}
